var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "staff") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.1215%",
    y1: "106.9%",
    x2: "62.7515625%",
    y2: "-7.09915625%",
    id: "staff-linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EFF00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF8C",
    offset: "99%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "staff",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C31.1046,0 32,0.895431 32,2 L32,30 C32,31.1046 31.1046,32 30,32 L2,32 C0.895431,32 0,31.1046 0,30 L0,2 C0,0.895431 0.895431,0 2,0 L30,0 Z M6,5 L6,27 L13.5029,27 L13.5029,22.1162 L16,22.1162 L16,24.5576 L18.4971,24.5576 L18.4971,27 L26,27 L26,19.6631 L23.5029,19.6631 L23.5029,17.2207 L20.9941,17.2207 L20.9941,14.7793 L23.5029,14.7793 L23.5029,12.3369 L26,12.3369 L26,5 L18.4971,5 L18.4971,7.44238 L16,7.44238 L16,9.88379 L13.5029,9.88379 L13.5029,5 L6,5 Z",
    id: "Shape",
    fill: "url(#staff-linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.066d85eb30ee63c5552cca0005ba685c.svg";
export { ForwardRef as ReactComponent };